const { env } = '@/env.js'
/**
 * @description 普通文章页分环境广告配置
 */
const articleAdConfigMap = {
    test: {
        // 右侧第一矩形(普通文章页)
        rightFirstRect: {
            "posCode": "10181",
            "rule": 1,
            "fixArray": [
                1
            ],
            "resourceId": "499991658719137982",
            "spmCCode": "ad-sq1",
            "el": '#god_1',
        },
        // 右侧第二矩形(普通文章页)
        rightSecondRect: {
            "posCode": "10180",
            "rule": 1,
            "fixArray": [
                1
            ],
            "resourceId": "499991658719137981",
            "spmCCode": "ad-sq2",
            "el": '#god_2',
        },
        // 右侧第三矩形(普通文章页)
        rightThirdRect: {
            "resourceId": "499991658719137949",
            "posCode": "10179",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-sq3",
            el: "#god_3",
        },
        // 右侧第四矩形(普通文章页)
        rightFourthRect: {
            "resourceId": "499991658719137948",
            "posCode": "10178",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-sq4",
            el: "#god_4"
        },
        // PC右侧第五矩形
        fifthAd: {
            "resourceId": "499991658719137947",
            "posCode": "10177",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "sqfive-ad",
            el: "#god_5",
        },
        // 左侧悬浮
        leftFix: {
            resourceId: "499991658719137946",
            "posCode": "10142",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-ss",
            el: "#left-bottom-god",
        },
        // 右侧矩形
        rightFix: {
            resourceId: "499991658719137945",
            "posCode": "10176",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-sq6",
            el: "#god_fix_1",
        },
        // 右侧冠名
        rightSponsor: {
            resourceId: "499991658719137943",
            "posCode": "10174",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right-sponsor",
            el: "#nav_button",
        },
        //全屏广告
        fullScreenSleep: {
            resourceId: "1009476205654769664",
            "posCode": "10190",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-fullScreenSleep",
            el: ".left-bottom-float-fullScreenSleep",
        },
        // 文末淘宝
        textLast: {
            resourceId: "499991658719137944",
            "posCode": "10175",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-text-bottom",
            el: "#god_bottom_banner"
        },
    },
    prod: {
        // 右侧第一矩形(普通文章页)
        rightFirstRect: {
            resourceId: "499991658718650019",
            "posCode": "10161",
            "rule": 1,
            "fixArray": [
                1
            ],
            "spmCCode": "ad-sq1",
            "el": '#god_1',
        },
        // 右侧第二矩形(普通文章页)
        rightSecondRect: {
            resourceId: "499991658718187103",
            "posCode": "10160",
            "rule": 1,
            "fixArray": [
                1
            ],
            "spmCCode": "ad-sq2",
            "el": '#god_2',
        },
        // 右侧第三矩形(普通文章页)
        rightThirdRect: {
            resourceId: "499991658718708503",
            "posCode": "10159",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-sq3",
            el: "#god_3",
        },
        // 右侧第四矩形(普通文章页)
        rightFourthRect: {
            resourceId: "499991658718708502",
            "posCode": "10158",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-sq4",
            el: "#god_4"
        },
        // PC右侧第五矩形
        fifthAd: {
            resourceId: "499991658718708501",
            "posCode": "10157",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "sqfive-ad",
            el: "#god_5",
        },
        // 左侧悬浮
        leftFix: {
            resourceId: "499991658718708504",
            "posCode": "10116",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-ss",
            el: "#left-bottom-god",
        },
        // 右侧悬浮
        rightFix: {
            resourceId: "499991658718708507",
            "posCode": "10156",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-sq6",
            el: "#god_fix_1",
        },
        // 右侧冠名
        rightSponsor: {
            resourceId: "499991658718708505",
            "posCode": "10154",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right-sponsor",
            el: "#nav_button",
        },
        //全屏广告
        fullScreenSleep: {
            resourceId: "1009475832936333312",
            "posCode": "10190",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-fullScreenSleep",
            el: ".left-bottom-float-fullScreenSleep",
        },
        // 文末淘宝
        textLast: {
            resourceId: "499991658718708506",
            "posCode": "10155",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-text-bottom",
            el: "#god_bottom_banner"
        },
    }
}

/**
 * @description 海外文章页分环境广告配置
 */
const abroadAdConfigMap = {
    test: {
        // 右侧第一矩形(普通文章页)
        rightFirstRect: {
            "posCode": "10181",
            "rule": 1,
            "fixArray": [
                1
            ],
            "resourceId": "1166412655326593024",
            "spmCCode": "ad-sq1",
            el: '#god_1_2'
        },
        // 右侧第二矩形(普通文章页)
        rightSecondRect: {
            "posCode": "10180",
            "rule": 1,
            "fixArray": [
                1
            ],
            "resourceId": "499991658719137981",
            el: '#god_2',
            spmCCode: 'ad-sq2',
        },
        // 右侧第三矩形(普通文章页)
        rightThirdRect: {
            "resourceId": "499991658719137949",
            "posCode": "10179",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#god_3',
            spmCCode: 'ad-sq3',
        },
        // 右侧第四矩形(普通文章页)
        rightFourthRect: {
            "resourceId": "499991658719137948",
            "posCode": "10178",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#god_4',
            spmCCode: 'ad-sq4',
        },
        // PC右侧第五矩形
        fifthAd: {
            "resourceId": "499991658719137947",
            "posCode": "10177",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#god_5',
            spmCCode: 'sqfive-ad',
        },
        // 右侧矩形
        rightFix: {
            resourceId: "499991658719137945",
            "posCode": "10176",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#god_fix_1',
            spmCCode: 'ad-sq6',
        },
        // 右侧冠名
        rightSponsor: {
            resourceId: "499991658719137943",
            "posCode": "10174",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#nav_button',
            spmCCode: 'ad-right-sponsor',
        },
        // 文末淘宝
        textLast: {
            resourceId: "499991658719137944",
            "posCode": "10175",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#god_bottom_banner',
            spmCCode: 'ad-text-bottom',
        },
    },
    prod: {
        // 右侧第一矩形(普通文章页)
        rightFirstRect: {
            resourceId: "499991658718650019",
            "posCode": "10161",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'ad-sq1',
            el: '#god_1_2',
        },
        // 右侧第二矩形(普通文章页)
        rightSecondRect: {
            resourceId: "499991658718187103",
            "posCode": "10160",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'ad-sq2',
            el: '#god_2',
        },
        // 右侧第三矩形(普通文章页)
        rightThirdRect: {
            resourceId: "499991658718708503",
            "posCode": "10159",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'ad-sq3',
            el: '#god_3',
        },
        // 右侧第四矩形(普通文章页)
        rightFourthRect: {
            resourceId: "499991658718708502",
            "posCode": "10158",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'ad-sq4',
            el: '#god_4',
        },
        // PC右侧第五矩形
        fifthAd: {
            resourceId: "499991658718708501",
            "posCode": "10157",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'sqfive-ad',
            el: '#god_5',
        },
        // 右侧悬浮
        rightFix: {
            resourceId: "499991658718708507",
            "posCode": "10156",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'ad-sq6',
            el: '#god_fix_1',
        },
        // 右侧冠名
        rightSponsor: {
            resourceId: "499991658718708505",
            "posCode": "10154",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'ad-right-sponsor',
            el: '#nav_button',
        },
        // 文末淘宝
        textLast: {
            resourceId: "499991658718708506",
            "posCode": "10155",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'ad-text-bottom',
            el: '#god_bottom_banner',
        },
        // 海外文章页第一和第二矩形之间taboola-desktop-right-rail
        jingxuanTaboola: {
            resourceId: "1166412492038144000",
            "posCode": "10576",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'jingxuan-taboola',
            el: '#jingxuan-taboola',
        },
        // 文末taboola广告
        articleBottomTaboola: {
            resourceId: "1166412377957269504",
            "posCode": "10575",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'a-content-end',
            el: '#article_bottom_banner',
        },
        // momagic插屏广告
        momagicScreen: {
            resourceId: "1210595906936832000",
            "posCode": "10593",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: 'a-momagic_screen-end',
            el: '#momagic_screen',
        },
    }
}

/**
 * @description 焦点文章页广告配置
 */
const focusAdConfigMap = {
    test: {
        focusTopBanner1: {
            resourceId: '3999991687166169000',
            "posCode": "10266",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-top1",
        }, // 焦点顶部通栏1
        focusTopBanner2: {
            resourceId: '3999991687185454000',
            "posCode": "10267",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-top2",
        }, // 焦点顶部通栏2
        focusTopBanner3: {
            resourceId: '3999991687185463000',
            "posCode": "10268",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-top3",
        }, // 焦点顶部通栏3
        focusSide1: {
            resourceId: '3999991687185469000',
            "posCode": "10272",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right1",
        }, // 侧边矩形广告1
        focusSide2: {
            resourceId: '3999991687185473000',
            "posCode": "10273",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right2",
        }, // 侧边矩形广告2
        focusSide3: {
            resourceId: '3999991687185479000',
            "posCode": "10274",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right3",
        }, // 侧边矩形广告3
        focusSide4: {
            resourceId: '3999991687185584000',
            "posCode": "10396",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right4",
        }, // 侧边矩形广告4
        focusSide5: {
            resourceId: '3999991687185591000',
            "posCode": "10397",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right5",
        }, // 侧边矩形广告1
        focusBottomBanner1: {
            resourceId: '3999991687185489000',
            "posCode": "10269",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-bottom1",
        }, // 底部通栏1
        focusBottomBanner2: {
            resourceId: '3999991687185501000',
            "posCode": "10270",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-bottom2",
        }, // 底部通栏2
        focusBottomBanner3: {
            resourceId: '3999991687185505000',
            "posCode": "10271",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-bottom3",
        }, // 底部通栏3
        focusBottomBanner4: {
            resourceId: '3999991687186021000',
            "posCode": "10276",
            "rule": 1,
            "fixArray": [
                1,
                2
            ],
            spmCCode: "ad-bottom4",
        }, // 底部通栏4
        focusRelativeInfo: {
            resourceId: '3999991687185530000',
            "posCode": "10275",
            "rule": 1,
            "fixArray": [
                4,
                8,
                12,
                16
            ],
            spmCCode: 'tjyd',
        }, // 相关资讯广告
        focusRightRecommend: {
            resourceId: '3999991687185482000',
            "posCode": "10283",
            "rule": 1,
            "fixArray": [
                6
            ],
            spmCCode: 'cnxh'
        }, // 右侧推荐阅读
    },
    prod: {
        focusTopBanner1: {
            "posCode": "10334",
            "rule": 1,
            "fixArray": [
                1
            ],
            resourceId: '3999991687166169000',
            spmCCode: "ad-top1",
        }, // 焦点顶部通栏1
        focusTopBanner2: {
            "posCode": "10335",
            "rule": 1,
            "fixArray": [
                1
            ],
            resourceId: '3999991687185454000',
            spmCCode: "ad-top2",
        }, // 焦点顶部通栏2
        focusTopBanner3: {
            resourceId: '3999991687185463000',
            "posCode": "10336",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-top3",
        }, // 焦点顶部通栏3
        focusSide1: {
            resourceId: '3999991687185469000',
            "posCode": "10340",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right1",
        }, // 侧边矩形广告1
        focusSide2: {
            resourceId: '3999991687185473000',
            "posCode": "10341",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right2",
        }, // 侧边矩形广告2
        focusSide3: {
            resourceId: '3999991687185479000',
            "posCode": "10342",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right3",
        }, // 侧边矩形广告3
        focusSide4: {
            resourceId: '3999991687185584000',
            "posCode": "10466",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right4",
        }, // 侧边矩形广告4
        focusSide5: {
            resourceId: '3999991687185591000',
            "posCode": "10467",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right5",
        }, // 侧边矩形广告1
        focusBottomBanner1: {
            resourceId: '3999991687185489000',
            "posCode": "10337",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-bottom1",
        }, // 底部通栏1
        focusBottomBanner2: {
            resourceId: '3999991687185501000',
            "posCode": "10338",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-bottom2",
        }, // 底部通栏2
        focusBottomBanner3: {
            resourceId: '3999991687185505000',
            "posCode": "10339",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-bottom3",
        }, // 底部通栏3
        focusBottomBanner4: {
            resourceId: '3999991687186021000',
            "posCode": "10344",
            "rule": 1,
            "fixArray": [
                1,
                2
            ],
            spmCCode: "ad-bottom4",
        }, // 底部通栏4
        focusRelativeInfo: {
            resourceId: '3999991687185530000',
            "posCode": "10343",
            "rule": 1,
            "fixArray": [
                4,
                8,
                12,
                16
            ],
            spmCCode: 'tjyd',
        }, // 相关资讯广告
        focusRightRecommend: {
            resourceId: '3999991687185482000',
            "posCode": "10351",
            "rule": 1,
            "fixArray": [
                6
            ],
            spmCCode: 'cnxh'
        }, // 右侧推荐阅读
    },
}

/**
 * @description 焦点家居文章页广告配置
 */
const focusHomeAdConfigMap = {
    test: {
        topBanner1: {
            resourceId: '3999991699239601000',
            "posCode": "10516",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-top1",
        }, // NOTE:已投放
        topBanner2: {
            resourceId: '3999991699239607000',
            "posCode": "10517",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-top2",
        }, // NOTE:已投放
        topBanner3: {
            resourceId: '3999991699272565000',
            spmCCode: "ad-top3",
        },
        side1: {
            resourceId: '3999991699239612000',
            "posCode": "10518",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right1",
        }, // NOTE:已投放
        side2: {
            resourceId: '3999991699271111000',
            spmCCode: "ad-right2",
        },
        side3: {
            resourceId: '3999991699271120000',
            spmCCode: "ad-right3",
        },
        side4: {
            resourceId: '3999991699239616000',
            "posCode": "10519",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-right4",
        }, // NOTE:已投放
        side5: {
            resourceId: '3999991699271130000',
            spmCCode: "ad-right5",
        },
        bottomBanner1: {
            resourceId: '3999991699239620000',
            "posCode": "10520",
            "rule": 1,
            "fixArray": [
                1
            ],
            spmCCode: "ad-bottom1",
        }, // NOTE:已投放
        bottomBanner2: {
            resourceId: '3999991699271185000',
            spmCCode: "ad-bottom2",
        },
        bottomBanner3: {
            resourceId: '3999991699272609000',
            spmCCode: "ad-bottom3",
        },
        bottomBanner4: {
            resourceId: '3999991699272617000',
            spmCCode: "ad-bottom4",
        },
        relativeInfo: {
            resourceId: '3999991700796847000',
            "posCode": "10275",
            "rule": 1,
            "mergeType": 0,
            "fixArray": [
                4,
                8,
                12,
                16
            ],
            spmCCode: 'tjyd'
        }, // 相关资讯广告
        rightRecommend: {
            resourceId: '3999991700796839000',
            "posCode":"10283",
            "rule":1,
            "fixArray":[
                6
            ],
            spmCCode: 'cnxh'
        }, // 右侧猜你喜欢
    },
    prod: {
        topBanner1: {
            resourceId: '3999991699239601000',
            "posCode": "10551",
            "rule": 1,
            "fixArray": [
                1
            ]
        }, // NOTE:已投放
        topBanner2: {
            resourceId: '3999991699239607000',
            "posCode": "10552",
            "rule": 1,
            "fixArray": [
                1
            ]
        }, // NOTE:已投放
        topBanner3: {
            resourceId: '3999991699272565000',
        },
        side1: {
            resourceId: '3999991699239612000',
            "posCode": "10553",
            "rule": 1,
            "fixArray": [
                1
            ]
        }, // NOTE:已投放
        side2: {
            resourceId: '3999991699271111000',
        },
        side3: {
            resourceId: '3999991699271120000',
        },
        side4: {
            resourceId: '3999991699239616000',
            "posCode": "10554",
            "rule": 1,
            "fixArray": [
                1
            ]
        }, // NOTE:已投放
        side5: {
            resourceId: '3999991699271130000',
        },
        bottomBanner1: {
            resourceId: '3999991699239620000',
            "posCode": "10555",
            "rule": 1,
            "fixArray": [
                1
            ]
        }, // NOTE:已投放
        bottomBanner2: {
            resourceId: '3999991699271185000',
        },
        bottomBanner3: {
            resourceId: '3999991699272609000',
        },
        bottomBanner4: {
            resourceId: '3999991699272617000',
        },
        relativeInfo: {
            resourceId: '3999991700796847000',
            "posCode": "10582",
            "rule": 1,
            "fixArray": [
                4,
                8,
                12,
                16
            ],
            spmCCode: 'tjyd',
        }, // 相关资讯广告
        rightRecommend: {
            resourceId: '3999991700796839000',
            "posCode": "10583",
            "rule": 1,
            "fixArray": [
                6
            ],
            spmCCode: 'cnxh'
        }, // 右侧猜你喜欢
    }
}



/**
 * @description 普通文章页广告配置
 */
export const articleAdConfig = articleAdConfigMap[env] || articleAdConfigMap.prod
/**
 * @description 海外文章页广告配置
 */
export const abroadAdConfig = abroadAdConfigMap[env] || abroadAdConfigMap.prod
/**
 * @description 焦点文章页广告配置
 */
export const focusAdConfig = focusAdConfigMap[env] || focusAdConfigMap.prod
/**
 * @description 焦点家居文章页广告配置
 */
export const focusHomeAdConfig = focusHomeAdConfigMap[env] || focusHomeAdConfigMap.prod